import * as THREE from 'three'
import Experience from "../Experience"
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils';

export default class Otter {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Setup
        this.resource = this.resources.items.otterModel

        // Instantiate the model
        this.instances = []

        this.setModel({
            position: new THREE.Vector3(0.8, 0.12, -5.7),
            animationIndex: 0,
            startTime: 0
        })

        this.setModel({
            position: new THREE.Vector3(-0.9, -0.01, -6),
            animationIndex: 1,
            startTime: -0.3
        })
    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel({ position, animationIndex, startTime }) {
        const modelClone = SkeletonUtils.clone(this.resource.scene)
        modelClone.position.copy(position)
        modelClone.children[0].scale.set(0.4, 0.4, 0.4)
        this.scene.add(modelClone)


        modelClone.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.receiveShadow = false
                child.castShadow = true
            }
        })

        this.scene.add(modelClone)
        this.setAnimation(animationIndex, startTime, modelClone)
    }

    setAnimation(animationIndex, startTime, modelClone) {
        const mixer = new THREE.AnimationMixer(modelClone)
        const action = mixer.clipAction(this.resource.animations[animationIndex])
        action.startAt(startTime).play()

        this.instances.push({ model: modelClone, mixer })
    }

    update() {
        for (const instance of this.instances) {
            instance.mixer.update(this.time.delta / 1000)
        }
    }
}